// extracted by mini-css-extract-plugin
export default {"link":"RX7NxXOlur"};